/* eslint-disable */
import template from "./paylateBnrTemplate.html"
import "./paylateBnr.scss"
export default function paylateBnr(hotelIndex) {
	return template({hotelIndex})
}